<template>
  <div class="wf-product-room-scene bg-white">
    <div class="d-flex">
      <div class="pr-2 d-none d-lg-block">
        <div v-if="selectedColor">
          <img
            class="wf-product-swatch-multi-tile wf-product-room-scene-viewer custom-cursor-active-for-images"
            id="wf-product-swatch-viewer-image-desktop"
            @click="productRoomSceneViewModal('swatch')"
            :src="isMultitile == true ? getInstallImgUrl(selectedInstallationMethod.name, 2000):
              $helpers.getColorThumbnailImageUrl(
                sellingStyleNumber,
                selectedColor.colorNumber,
                selectedProduct.productSizeImperial ? selectedProduct.productSizeImperial.toLowerCase().replace(/ /g, '').replace('x', '-').replace(/[a-zA-Z]/g, '').replace('-', 'x') : null,
                productData.productTypeDesc
              )
            "
            alt="img"
            @error="handleThumbnailImageError"
            @load="applyPanzoom"
          />
          <div>
            <div class="images-type-toggler-options">
              <button
                v-if="!hideSwatchMultiTileButtons.includes(productData.productTypeDesc.toLowerCase())"
                class="wf-product-room-scene-swatch border-0 shadow"
                :class="getViewOptions === 'swatch' ? 'font-weight-bold' : 'color-light-grey'"
                @click="toggleMode(false); applyPanzoom()"
              >
                {{ $resourceString['product.Details.Swatch.Label'] }}
              </button>
              <button
                v-if="!hideSwatchMultiTileButtons.includes(productData.productTypeDesc.toLowerCase())"
                class="wf-product-room-scene-multiple border-0 shadow"
                :class="getViewOptions === 'multi' ? 'font-weight-bold' : 'color-light-grey'"
                @click="toggleMode(true); applyPanzoom()"
              >
                {{ $resourceString['product.Details.MultiTile.Label'] }}
              </button>
              <button
                v-if="videoURL"
                class="wf-product-room-scene-video border-0 shadow font-weight-bold"
                @click="productRoomSceneViewModal('360Video')"
              >
                {{ $resourceString['product.Details.Label.Video'] }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="wf-product-room-scene-view">
        <!-- Room Scene Viewer -->
        <div
          class="wf-product-room-scene-viewer d-none d-lg-block"
          :class="isRug && viewMode === 'swatch' ? 'rug-image' : ''"
        >
          <!-- Room view mode controls -->
          <template>
            <button
              class="
                  btn
                  wf-product-room-scene-viewer-button
                  wf-product-room-scene-viewer-button-previous
                "
              type="button"
              @click="setPreviousRoomScene"
              v-if="roomScenes.length > 1"
            >            
              <span
                class="png-icon png-icon-icons-glyph--k-chevron-left"
                aria-label="Previous room scene"
              />
            </button>
            <button
              class="
                  btn
                  wf-product-room-scene-viewer-button
                  wf-product-room-scene-viewer-button-next
                "
              type="button"
              @click="setNextRoomScene"
              v-if="roomScenes.length > 1"
            >
              <span
                class="png-icon png-icon-icons-glyph--k-chevron-right"
                aria-label="Next room scene"
              />
            </button>
          </template>

          <div class="row h-100">
            <div class="col-md-9 pr-2 pl-0">
              <!-- Room Scene Image -->
              <wf-load-image
                :wrapper-class="'wf-product-room-scene-viewer-display'"
                :image-class="`wf-product-room-scene-viewer-image custom-cursor-active-for-images`"
                id="wf-product-room-scene-viewer-image-desktop"
                :src="getRoomSceneImageUrl(selectedRoomScene, 3000)"
                :alt="''"
                :image-load="applyPanzoom"
                :click="(e) => productRoomSceneViewModal('roomscene')"
              />
            </div>
            <div class="col-md-3 p-0">
              <wf-load-image
                :wrapper-class="'wf-product-room-scene-viewer-display'"
                :image-class="`wf-product-room-scene-viewer-image h-100`"
                :src="getRoomSceneImageUrl(selectedRoomScene && getNextRoomScene(), 3000)"
                :alt="''"
              />
            </div>
          </div>
        </div>

        <!-- mobile & tablet view  -->
        <div class="d-lg-none">
          <div
            class="wf-product-room-scene-viewer"
            :class="{'mb-4 bg-white': viewMode === 'swatch' || viewMode === 'multi'}"
          >
            <!-- Room view mode controls -->
            <div :class="getViewOptions === 'room'?'':'d-none d-lg-block'">
                <button
                  class="
                      btn
                      wf-product-room-scene-viewer-button
                      wf-product-room-scene-viewer-button-previous
                    "
                  type="button"
                  @click="setPreviousRoomScene"
                  v-if="roomScenes.length > 1"
                >
                  <span
                    class="png-icon png-icon-icons-glyph--k-chevron-left"
                    aria-label="Previous room scene"
                  />
                </button>
                <button
                  class="
                      btn
                      wf-product-room-scene-viewer-button
                      wf-product-room-scene-viewer-button-next
                    "
                  type="button"
                  @click="setNextRoomScene"
                  v-if="roomScenes.length > 1"
                >
                  <span
                    class="png-icon png-icon-icons-glyph--k-chevron-right"
                    aria-label="Next room scene"
                  />
                </button>
            </div>
            
            <!-- Room Scene Image -->
            <img
              v-if="getViewOptions === 'swatch' || getViewOptions === 'multi'"
              class="wf-product-swatch-viewer-display custom-cursor-active-for-images"
              :src="getViewOptions === 'swatch'? $helpers.getColorThumbnailImageUrl(
                    sellingStyleNumber,
                    selectedColor.colorNumber
                  ):getInstallImgUrl()"
              :alt="'img'"
              @error="handleImageError"
              @click="productRoomSceneViewModal('swatch')"
            />
            <wf-load-image
              v-else
              :wrapper-class="'wf-product-room-scene-viewer-display'"
              :image-class="`wf-product-room-scene-viewer-image custom-cursor-active-for-images`"
              :src="getRoomSceneImageUrl(selectedRoomScene, 3000)"
              :alt="''"
              :click="(e) => productRoomSceneViewModal('roomscene')"
            />
          </div>
        </div>

        <!-- mobile collapse icon -->
          <pc-view-options
            :installationMethods="installationMethods"
            @view-option-changed="handleViewOptionChanged"
            @install-option-changed="handleInstallationMethodClick"
          />

        <!-- Room Scene Pagination -->
            <div class="px-4 wf-product-room-scene-image-pagination" :class="getViewOptions === 'room'?'':'d-none d-lg-block'">
              <ul class="wf-product-room-scene-image-pagination-list">
                <li
                  class="wf-product-room-scene-image-pagination-item"
                  v-for="(roomScene, index) in roomScenes"
                  :key="roomScene.data"
                >
                  <button
                    class="btn wf-product-room-scene-image-pagination-item-button"
                    type="button"
                    :class="
                      roomScene === selectedRoomScene
                        ? 'wf-product-room-scene-image-pagination-item-button-active'
                        : ''
                    "
                    :aria-label="'View room scene number ' + roomScene"
                    @click="
                      setRoomSceneIndex(index);
                      updateQueryStringParameters(
                        $config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
                        roomScene.data
                      );
                    "
                  >
                  </button>
                </li>
              </ul>
            </div>
          </div>
    </div>

    <!-- Visualization Menu Bar Desktop -->
    <div class="container-fluid d-none d-lg-block pdp-section-space pdp-section-left-space" v-if="productData.productTypeDesc.toLowerCase() != $resourceString['productCategory.ResinousFlooring'].toLowerCase()">
      <div class="mb-5 row">
        <div class="col-lg-8">
          <div class="row">
            <!-- INSTALLATION METHODS MENU -->
            <div
              class="col-md-6 col-lg-4"
              :class="{ expanded: expandedFormGroup === 'installMethod' }"
            >
              <div class="dropdown-underline font-16 pb-3">
                <label
                  class="installation-methods-label"
                  for="install-method-select"
                >
                  {{ $resourceString['product.details.room.scene.installation.method'] }}
                </label>
                <select
                  class="border-0 cursor-pointer custom-dropdown text-uppercase"
                  v-model="formSelectedInstallationMethod"
                >
                  <option
                    v-for="installationMethod in installationMethods"
                    :key="installationMethod.code"
                    :value="installationMethod.tricycleCode || installationMethod.code"
                  >
                    {{ installationMethod.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- CHANGE ROOM SCENES MENU -->
            <div
            :class="{
              expanded: expandedFormGroup === 'changeRoom',
              '': categoriesWithoutDuplicates.length > 0
            }"
            class="col-md-6 col-lg-4"
            >
              <div class="dropdown-underline font-16 pb-3" v-if="categoriesWithoutDuplicates.length > 0">
                <label
                  class="change-room-scene-label font-16"
                  for="change-room-scene-select"
                >
                  {{ $resourceString['product.Details.RoomSegment.Label'] }}:
                </label>
                <select
                  id="change-room-scene-select"
                  class="border-0 cursor-pointer custom-dropdown text-uppercase pr-2"
                    v-model="selectedSegmentCategory"
                    @change="handleMobileCategoryChange"
                    :class="{ active: expandedFormGroup === 'changeRoom' }"
                  >
                    <option
                      v-for="cat in categoriesWithoutDuplicates"
                      :key="cat"
                      :value="cat"
                    >
                      {{ cat }}
                    </option>
                  </select>
              </div>
            </div>

            <!-- DOWNLOAD IMAGES MENU -->
            <div
              class="col-md-6 col-lg-4 text-right pr-0"
              :class="{ expanded: expandedFormGroup === 'downloadImages' }"
            >
              <button
                class="btn btn-white border-accent-gray-alt download-images-label bg-transparent"
                for="download-images-select"
                @click="toggleExpanded('downloadImages')"
              >
                <span
                  class="png-icon png-icon-icons-glyph--k-btn-download mr-3"
                ></span>
                {{ $resourceString['product.Details.DownloadHD.Button'] }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>



    <modal
      top="0"
      height="100%"
      width="100%"
      left="0"
      name="show-swatch-modal"
      class="swatch-viewer-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-product-swatch-view-modal :viewMode="viewSwatch" :isRug="isRug" @setViewMode="setViewMode">
        <img
          v-if="viewSwatch === 'swatch'"
          class="wf-product-swatch-viewer-display zoomable"
          :src="isMultitile === true? getInstallImgUrl(selectedInstallationMethod.name, 2000) :  $helpers.getColorThumbnailImageUrl(
                sellingStyleNumber,
                selectedColor.colorNumber,
                selectedProduct.productSizeImperial ? selectedProduct.productSizeImperial.toLowerCase().replace(/ /g, '').replace('x', '-').replace(/[a-zA-Z]/g, '').replace('-', 'x') : null,
                productData.productTypeDesc
              )"
          :alt="'img'"
          @error="handleThumbnailImageError"
        />
      </pc-product-swatch-view-modal>
    </modal>

    <modal
      height="550"
      width="1250"
      left="0"
      name="show-download-view-modal"
      class="download-hd-images-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <!-- Download popup -->
      <pc-product-download-view-modal>
        <div class="download-images-menu-content">
          <div class="download-images-menu-left">
            <ul class="menu-ul">
              <li
                class="menu-left-item dropdown-item-room-menu-left change-room-segments"
                v-for="tab in tabs"
                :key="tab.name"
                href="#"
                @click.prevent.stop="selectDownloadTab(tab)"
                :class="{ active: selectedTab === tab }"
              >
                {{ tab.tabLinkText }}
              </li>
            </ul>
            <div class="download-images-dropdown-triangle"></div>
          </div>

          <div class="download-images-menu-right">
            <div class="download-images-menu-select-all-option" v-if="(selectedTab.name !== tabs[1].name) && ((selectedTab.name === tabs[2].name && roomScenes && roomScenes.length > 0) || (selectedTab.name === tabs[0].name && availableVariations && availableVariations.length > 0))">
              <label for="selectallfordownloadimages">
                <input
                  type="checkbox"               
                  class="select-all-checkbox"
                  id="selectallfordownloadimages"
                  :checked="getIsAllSelectedDownload"
                  @change="downloadImagesSelectAllHandler"
                />
                <span>{{ getIsAllSelectedDownload ? $resourceString['product.Details.DownloadImages.UnSelectAll.Label'] : $resourceString['product.Details.DownloadImages.SelectAll.Label']}}</span>
              </label>
            </div>
            <div class="download-images-menu-right-wrap">
              <ul class="menu-ul" :class="selectedTab.name === 'installation'?'':'download-images-grid mt-4'">
                <!-- Download Room Scene Images -->
                <li
                  v-for="(roomScene, index) in roomScenes"
                  :key="roomScene.data + '_roomScene'"
                  v-if="
                    selectedTab.name === tabs[2].name &&
                    (!hasStaticImage || index < roomScenes.length - staticCount)
                  "
                >
                  <figure>
                    <label class="image-box-container">
                      <input
                        type="checkbox"
                        v-model="selectedImages"
                        :value="roomScene.data"
                        class="image-checkbox download-checkbox"
                      />
                      <img
                        class="room-img-thumb"
                        :src="getRoomSceneImageUrl(roomScene, 180)"
                        alt="img"
                        @load="handleImageLoad"
                        @error="handleImageError"
                      />
                      <span class="checkbox-overlay"></span>
                    </label>
                  </figure>
                </li>
                <!-- Download Installation Method Images -->
                <li v-if="selectedTab.name === 'installation'">
                  <figure>
                    <label class="image-box-container">
                      <input type="checkbox" :disabled="true" v-show="false" v-model="selectedImages" :value="getdownloadInstallationMethod.name" class="image-checkbox download-checkbox" />

                      <img
                        :class="selectedTab.name === 'installation'?'w-100':'installation-img-thumb'"
                        :src="getInstallImgUrl(getdownloadInstallationMethod.name, 325)"
                        alt="img"
                        @load="handleImageLoad"
                        @error="handleImageError"
                      />
                      <span class="checkbox-overlay"></span>
                    </label>
                  </figure>
                </li>
                <!-- Download Swatch Variant Images-->
                <li
                  v-for="variant in availableVariations"
                  :key="variant + '_swatchImg'"
                  v-if="selectedTab.name === tabs[0].name && availableVariations && availableVariations.length > 0"
                >
                  <figure>
                    <label class="image-box-container">
                      <input
                        type="checkbox"
                        v-model="selectedImages"
                        :value="variant"
                        class="image-checkbox download-checkbox"
                      />
                      <img
                        :src="
                          getSwatchImageUrl(
                            selectedProductWidth,
                            selectedProductHeight,
                            variant
                          )
                        "
                        class="w-100 cursor-pointer"
                        crossorigin="anonymous"
                        alt="img"
                        @load="handleImageLoad"
                        @error="handleImageError"
                      />
                      <span class="checkbox-overlay"></span>
                    </label>
                  </figure>
                </li>
              </ul>

              <div class="wf-load-image-status"
                v-if="isLoading &&
                !(selectedTab.name === tabs[0].name && (!availableVariations || availableVariations.length === 0)) &&
                !(selectedTab.name === tabs[1].name && !getInstallImgUrl(getdownloadInstallationMethod.name, 325)) &&
                !(selectedTab.name === tabs[2].name && roomScenes.length === 0)
              ">
                <div class="spinner-border" role="status">
                </div>
              </div>

              <div class="no-swatch-variations-container" v-if="selectedTab.name === tabs[0].name && (!availableVariations || availableVariations.length === 0)">
                <h3>{{ $resourceString['product.Details.NoSwatch.Placeholder'] }}</h3>
              </div>
              <div
                  v-if="selectedTab.name === tabs[1].name && !getInstallImgUrl(getdownloadInstallationMethod.name, 325)"
                  class="no-swatch-variations-container">
                  {{ $resourceString['common.NoDataAvailable.Msg'] }}
              </div>
              <div
                  v-if="selectedTab.name === tabs[2].name && roomScenes.length === 0"
                  class="no-swatch-variations-container">
                  {{ $resourceString['common.NoDataAvailable.Msg'] }}
              </div>
            </div>
            
          </div>
          <div id="wf-download-modal-spiner" class="spinner d-none">
            <div class="spinner-border" role="status">
              <span class="sr-only">{{ $resourceString['product.Details.Loading.Placeholder'] }}</span>
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-3 download-images-menu-content-footer">
          <div class="col-md-1 col-lg-3"></div>
          <div class="col-md-5 col-lg-4 ml-3">
            <div class="dropdown-underline font-16 pb-3"  v-if="selectedTab.name === tabs[1].name && productData.productTypeDesc.toLowerCase() != $resourceString['productCategory.ResinousFlooring'].toLowerCase()">
            <label
              class="installation-methods-label"
              for="install-method-select"
            >
              {{ $resourceString['product.details.room.scene.installation.method'] }} :
            </label>
            <select
              class="border-0 cursor-pointer font-weight-bold custom-dropdown text-uppercase"
              v-model="downloadInstallationMethod"
            >
              <option
                v-for="installationMethod in installationMethods"
                :key="installationMethod.code"
                :value="installationMethod.tricycleCode || installationMethod.code"
              >
                {{ installationMethod.name }}
              </option>
            </select>
          </div>
          </div>
          <div class="col-md-5 col-lg-4">
            <div
                v-if="
                  (selectedTab.name !== tabs[0].name &&
                    selectedInstallationMethod.name
                      .toLowerCase()
                      .includes('reverse')) ||
                    !selectedInstallationMethod.name
                      .toLowerCase()
                      .includes('reverse')
                "
                class="download-button-container"
              >
                <button :disabled="selectedImages && selectedImages.length == 0"
                  :class ="selectedImages && selectedImages.length == 0? 'btn-light':'btn-white'"
                  class="btn btn-hd-img-download text-uppercase border border-accent-gray-alt w-65 justify-content-start font-weight-bold"
                  @click="downloadImages(), toggleExpanded('downloadImages')"
                >
                  <span
                    class="png-icon png-icon-icons-glyph--k-btn-download mr-3"
                  ></span>
                  {{ $resourceString['product.Details.DownloadHD.Button'] }}
                </button>
            </div>
          </div>
        </div>
      </pc-product-download-view-modal>
    </modal>
    <!-- product swatch images and room scene view hero modal-->
    <pc-product-swatch-roomscene-view-hero-modal 
    :updateQueryStringParameters="updateQueryStringParameters" 
    :expandedFormGroup="expandedFormGroup"
    :installationMethods="installationMethods" 
    :product="product"
    :segments="segments"
    :segmentrooms="segmentrooms"
    :collectionsegments="collectionsegments"
    :roomscenenumbers="roomscenenumbers"
    :segmentRoomScenes="segmentRoomScenes"
    :mappedColors="mappedColors"
    :hideModal="productRoomSceneCloseModal"
    :viewProductType="viewProductType"
    :isMultitile="isMultitile"
    :toggleModeForProductImage="toggleMode"
    :getInstallImgUrl="getInstallImgUrl"
    :getRoomSceneImageUrl="getRoomSceneImageUrl"
    :hideSwatchMultiTileButtons="hideSwatchMultiTileButtons"
    :videoURL="videoURL"
    @color-changed="updateColor"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WFLoadImage from "../wf-load-image.vue";
import Panzoom from "@panzoom/panzoom";
import WFTabContent from "../wf-download-image-modal-tab-content.vue";
import PcProductSwatchViewModal from "./pc-product-swatch-view-modal.vue";
import pcProductDownloadViewModal from "./pc-product-download-view-modal.vue";
import { globalIcons } from "../../../constants/global";
import PcViewOptions  from "./pc-view-options.vue";
import PcProductSwatchRoomsceneViewHeroModal from "./pc-product-swatch-roomscene-view-hero-modal.vue"

let panzoomInstance = null;

export default {
  props: [
    "mappedColors",
    "installationMethods",
    "product",
    "segments",
    "segmentrooms",
    "collectionsegments",
    "roomscenenumbers",
    "segmentRoomScenes",
    "isTrusteduserDetails",
    "isViewinmyroomEnabled"
  ],
  data() {
    return {
      viewMode: "swatch",
      viewSwatch: "",
      isMultitile: false,
      hasStaticImage: false,
      staticCount: 0,
      selectedProductWidth: null,
      selectedProductHeight: null,
      expandedFormGroup: null,
      selectedTab: null,
      selectedSegmentCategory: "",
      selectedImages: [],
      availableVariations: [],
      isLoading: true,
      hideSwatchMultiTileButtons: [this.$resourceString['productCategory.ResinousFlooring'].toLowerCase(), this.$resourceString['productCategory.Sheet'].toLowerCase(), this.$resourceString['productCategory.Broadloom'].toLowerCase()],
      defaultImage:globalIcons.defaultImage,
      tabs: [
        {
          name: "swatch",
          tabLinkText: "Individual Tile Variations",
        },
        {
          name: "installation",
          tabLinkText: "Repeatable Tile Installations",
        },
        {
          name: "roomscene",
          tabLinkText: "Room Scenes",
        }
      ],
      formSelectedRoomSegment: "Retail",

      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      viewProductType: ""
    };
  },
  computed: {
    ...mapGetters({
      featureImages: "inspirationPage/images",
      categories: "productDetail/categories",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      colors: "productDetail/colors",
      selectedColor: "productDetail/color",
      selectedRoomScene: "productDetail/roomScene",
      roomScenes: "productDetail/roomScenes",
      roomSceneIndex: "productDetail/roomSceneIndex",
      categoryName: "productDetail/categoryName",
      productVisualizerURL: "productDetail/productVisualizerURL",
      selectedInstallationMethod: "productDetail/installationMethod",
      isComingSoonProduct: "productDetail/isComingSoonProduct",
      isRug: "productDetail/isRug",
      selectedProduct: "productDetail/selectedProduct",
      productData: "productDetail/productData",
      sortOrder: "filters/sortOrder",
      filters: "filters/filters",
      getMarketSegmentTypes: "productDetail/getMarketSegmentTypes",
      getVisibleThreeDButton: "productDetail/getVisibleThreeDButton",
      getEnable3DSource: "productDetail/getEnable3DSource",
      getThreeDSourceURL: "productDetail/getThreeDSourceURL",
      getThreeDSourceIcon: "productDetail/getThreeDSourceIcon",
      open: "productDetail/openDownloadFileModal",
      getUserGUID: "productDetail/getUserGUID",
      getdownloadInstallationMethod: "productDetail/getdownloadInstallationMethod",
      getViewOptions: "productDetail/getViewOptions"
    }),
    formSelectedInstallationMethod: {
      // Use computed property to handle form binding with Vuex state
      get() {
        return this.selectedInstallationMethod.tricycleCode ?? this.selectedInstallationMethod?.code;
      },
      set(value) {
        let installationMethod = this.installationMethods.find(
          i => (i.tricycleCode ?? i.code) === value
        );
        this.setInstallationMethod(installationMethod);
        this.updateQueryStringParameters(
          this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME,
          installationMethod.name
        );
      },
    },
    downloadInstallationMethod: {
      // Use computed property to handle form binding with Vuex state
      get() {
        return this.getdownloadInstallationMethod.tricycleCode ?? this.getdownloadInstallationMethod?.code;
      },
      set(value) {
        let installationMethod = this.installationMethods.find(
          i => (i.tricycleCode ?? i.code) === value
        );
        this.setdownloadInstallationMethod(installationMethod);

        if(this.selectedTab.name == 'installation'){
          this.selectDownloadTab(this.tabs[1]);
        }
      },
    },
    categoriesWithoutDuplicates() {
      const uniqueCategories = [...new Set(this.categories)];
      return uniqueCategories;
    },
    installationMethodItems: function() {
      return this.installationMethods.map(i => ({
        name: i.name,
        value: (i.tricycleCode ?? i.code),
        currentInstallation: this.getdownloadInstallationMethod
      }));
    },
    roomSceneItems: function() {
      return this.roomScenes.map(i => ({
        name: i.type,
        value: i.data,
        currentRoomScene: this.selectedRoomScene
      }));
    },
    imageClass() {
      return `zoom-${this.zoomLevel}`;
    },
    getIsAllSelectedDownload() {
      return this.selectedImages.length === (
                    this.selectedTab.name === this.tabs[0].name 
                    ? this.availableVariations.length 
                    : this.selectedTab.name === this.tabs[2].name 
                    ? this.roomScenes.length : 0
             )                  
    },
    videoURL() {
      if (!this.productData || !this.productData.colors || !this.selectedColor) return null;
      
      const selectedColorInfo = this.productData.colors.find(c => 
        c.colorNumber === this.selectedColor.colorNumber
      );
      
      if (!selectedColorInfo || !selectedColorInfo.imagesInfo) return null;
      
      const rotationVideo = selectedColorInfo.imagesInfo.find(img => 
        img && img.type === "Rotation360"
      );
      
      return rotationVideo ? rotationVideo.url : null;
    }
  },
  methods: {
    ...mapActions({
      setCategories: "productDetail/setCategories",
      setColor: "productDetail/setColor",
      setColors: "productDetail/setColors",
      setRoomSceneIndex: "productDetail/setRoomSceneIndex",
      setRoomScenes: "productDetail/setRoomScenes",
      setCategoryName: "productDetail/setCategoryName",
      setProductVisualizerURL: "productDetail/setProductVisualizerURL",
      setInstallationMethod: "productDetail/setInstallationMethod",
      setdownloadInstallationMethod: "productDetail/setdownloadInstallationMethod",
      setInstallationMethods: "productDetail/setInstallationMethods",
      setProductData: "productDetail/setProductData",
      setSellingStyleNumber: "productDetail/setSellingStyleNumber",
      setRoomsFromCategory: "productDetail/setRoomsFromCategory",
      fetchResults: "inspirationPage/fetchResults",
      marketSegmentType: "productDetail/marketSegmentType",
      visibleThreeDButton: "productDetail/visibleThreeDButton",
      setOpenDownloadFileModal: "productDetail/setOpenDownloadFileModal",
      setViewOptions:"productDetail/setViewOptions"
    }),

    handleResize() {
      this.windowSize.width = window.innerWidth;
      this.windowSize.height = window.innerHeight;
      if(this.windowSize.width || this.windowSize.height)
      this.applyPanzoom();
    },

    handleViewOptionChanged(value) {
      this.viewMode = value;
      if (value === 'swatch') {
        this.toggleMode(false);
      } else if (value === 'multi') {
        this.toggleMode(true);
      } else if (value === '360Video') {
        this.setViewOptions("360Video");
        this.productRoomSceneViewModal('360Video');
      }
    },

    handleImageLoad(event) {
      this.isLoading = false;
    },

    handleImageError(event) {
      event.target.src = this.defaultImage;
    },

    handleThumbnailImageError(event) {
      if(event.target.src.toLowerCase().includes("thumbnail") || event.target.src.toLowerCase().includes("installs")){
        event.target.src = this.defaultImage;
      }
      else{
        event.target.src = this.$helpers.getColorThumbnailImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber
        );
      }
    },
    toggleMode(mode) {
      this.isMultitile = mode;
      if (mode === "360Video") {
        this.setViewOptions("360Video");
      } else if (mode === true) {
        this.setViewOptions("multi");
      } else {
        this.setViewOptions("swatch");
      }
    },
    showModal(name) {
      this.$modal.show(name + "-modal");
    },
    //Main Roonscene
    getSelectedSegmentCategory(e, queryCategory) {
      let categoryName;
      if (queryCategory) {
        categoryName = queryCategory;
      } else {
        categoryName = e.target.getAttribute("data-name");
      }
      this.setCategoryName(categoryName);

      // Updates url with selected category
      this.updateQueryStringParameters(
        this.$config.queryParamNames.CATEGORY_QUERY_PARAM_NAME,
        categoryName
      );
      this.changeInspiration(categoryName);

      // Set room scene index back to the first scene when the category changes
      this.setRoomSceneIndex(0);

      // Declare array with backend segment info from Kentico
      const segmentRoomScenesArray = this.segmentRoomScenes.segmentRoomScenes;

      // Variable for storing rScenes that match the selected category
      let roomSceneIDs = [];

      segmentRoomScenesArray.forEach((element, i) => {
        if (this.categoryName === segmentRoomScenesArray[i].segmentName) {
          roomSceneIDs.push(segmentRoomScenesArray[i].roomScenes.split(","));
        }
      });

      roomSceneIDs = roomSceneIDs[0].map(Number);

      // Stores static scenes if the selected color has any
      let staticRoomSceneImages = this.selectedColor.roomScenes ?? [];

      this.staticCount = staticRoomSceneImages.length;

      // Checks to see if the current category has static images
      staticRoomSceneImages.length
        ? (this.hasStaticImage = true)
        : (this.hasStaticImage = false);

      // Sets room scenes based on the conditional
      if (this.hasStaticImage) {
        this.setRoomScenes(
          [].concat(
            roomSceneIDs.map(i => {
              return { type: "interactive", data: i };
            }),
            staticRoomSceneImages.map(s => {
              return { type: "static", data: s };
            })
          )
        );
      } else {
        roomSceneIDs = roomSceneIDs.map(id => ({
          data: id,
          type: "interactive"
        }));
        this.setRoomScenes(roomSceneIDs);
      }

      // Updates url with the room scene id of the selected category
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[0].data
      );

      // Remove the 'active' class from all li elements
      const liElements = document.querySelectorAll(
        ".dropdown-item-room-menu-left"
      );
      liElements.forEach(li => {
        li.classList.remove("active");
      });

      // Add the 'active' class to the clicked li element
      if (e) {
        e.target.classList.add("active");
      }
    },
    async changeInspiration(categoryName) {
      await this.marketSegmentType();
      let category = "";
      let isCategoryAvailable = this.getMarketSegmentTypes.find(
        element => element == categoryName
      );
      if (isCategoryAvailable) {
        category = isCategoryAvailable;
      }
      this.fetchResults({
        filter: {
          SegmentType: category,
          sellingStyleNumber: this.productData.sellingStyleNumber,
          Collection: this.productData.collection,
          IncludeTotalResultCount: true,
          PageSize: 15,
          IsAscendingOrder: true,
          IsPDP: true
        },
        includefilters: true
      });
    },
    goToStaticScene: function() {
      //set general scenes to be displayed by changing category name and updating array
      //navigate to static scene by going to last index of array
      this.setCategoryName("General");
      this.updateColor(this.selectedColor);
      this.setRoomSceneIndex(this.roomScenes.length - 1);
    },
    getInstallImgUrl: function(installationMethod, size) {
      if (this.isRug) {
        return this.$helpers.getRugColorInstallImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber,
          this.selectedProduct?.shape,
          this.selectedProduct.productSizeImperial ? this.selectedProduct.productSizeImperial.toLowerCase().replace(/ /g, "").split("x") : null,
        );
      }
      return this.$helpers.getColorTopDownInstallImageUrl(
        this.sellingStyleNumber,
        this.selectedColor.colorNumber,
        installationMethod || this.selectedInstallationMethod.name,
        size ? size : null
      );
    },
    updateColor: function(color) {
      // Set color state
      this.setColor(color);
    
      this.visibleThreeDButton();

      let url = new URL(window.location);
      // Replace URL path to include updated color
      window.history.replaceState(
        null,
        null,
        `/product/detail/${this.productData.styleNameURL}-${
          this.sellingStyleNumber
        }/${color.colorNumber}${
          url.searchParams ? "?" + url.searchParams.toString() : null
        }`
      );
    },
    setPreviousRoomScene: function() {
      let index = (this.roomSceneIndex - 1) % this.roomScenes.length;
      index = index < 0 ? 0 : index;

      this.setRoomSceneIndex(index);
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[this.roomSceneIndex].data
      );
    },
    setNextRoomScene: function() {
      let index = (this.roomSceneIndex + 1) % this.roomScenes.length;
      index =
        index >= this.roomScenes.length ? this.roomScenes.length - 1 : index;

      this.setRoomSceneIndex(index);
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[this.roomSceneIndex].data
      );
    },
    getNextRoomScene: function() {
      let index = (this.roomSceneIndex + 1) % this.roomScenes.length;
      index =
        index >= this.roomScenes.length ? this.roomScenes.length - 1 : index;

      return this.roomScenes[index];
    },
    getRoomSceneImageUrl: function (roomScene, size) {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[this.roomSceneIndex].data
      );
      if (roomScene.type === "interactive") {
        // Get interactive room scene image
        if (this.isRug) {
          return this.$helpers.getRugRoomSceneImageUrl(
            this.sellingStyleNumber,
            this.selectedColor.colorNumber,
            roomScene.data,
            this.selectedProduct?.shape,
            this.selectedProduct.productSizeImperial ? this.selectedProduct.productSizeImperial.toLowerCase().replace(/ /g, "").split("x") : null,
          );
        }
        return this.$helpers.getInteractiveRoomSceneImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber,
          roomScene.data,
          this.selectedInstallationMethod?.name,
          size,
          this.product.productTypeDesc,
          this.product.inventoryType
        );
      } else {
        // Get static room scenes from raw URL in data
        return roomScene.data;
      }
    },
    setViewMode: function(viewMode) {
      if (viewMode === "swatch") {
        this.showModal("show-swatch");
        this.viewSwatch = viewMode;
      } else {
        this.viewMode = viewMode;
      }
    },
    redirectTo3DSource: function(url) {
      window.open(url, "_blank");
    },
    applyPanzoom: function() {
      // Clean up existing panzoom instance
      // if (panzoomInstance) {
      //   panzoomInstance.destroy();
      // }

      const parentNode = document.getElementById('wf-product-swatch-viewer-image-desktop');
      const imageNode = document.querySelector('#wf-product-room-scene-viewer-image-desktop img');
      try {
        // panzoomInstance = Panzoom(imageNode, {
        //   startScale: 1,
        //   startX: 0,
        //   startY: ((parentNode.offsetHeight - imageNode.offsetHeight) / 2),
        //   contain: "outside"
        // });
        imageNode.style.transform = 'scale(1) translate(0px, ' + ((parentNode.offsetHeight - imageNode.offsetHeight) / 2) + 'px)';
      } catch {
        // Fail silently when panzoom can't initialize, likely due to the DOM element being removed
      }
    },
    updateQueryStringParameters: function(queryParameter, value) {
      const url = new URL(window.location);
      if (value === null) {
        url.searchParams.delete(queryParameter);
      } else {
        url.searchParams.set(queryParameter, value);
      }
      window.history.replaceState(
        null,
        null,
        url.origin + url.pathname + "?" + url.searchParams
      );
    },
    // Visualization Bar
    toggleExpanded(formGroup) {
      if (formGroup === "downloadImages") {
        this.showModal("show-download-view");
      }
      if (this.expandedFormGroup === formGroup) {
        this.expandedFormGroup = null;
      } else {
        this.expandedFormGroup = formGroup;
      }
    },
    handleInstallationMethodClick(installationMethod) {
      this.setInstallationMethod(installationMethod);
      this.updateQueryStringParameters(
        this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME,
        installationMethod.name
      );
    },
    getSelectedProductDimensions() {
      const dimensions = this.selectedProduct.productSizeImperial 
        ? this.selectedProduct.productSizeImperial.trim().split("x") 
        : null;
      if (dimensions?.length === 2) {
        this.selectedProductWidth = parseFloat(dimensions[0].trim());
        this.selectedProductHeight = parseFloat(dimensions[1].trim());
      }
    },
    handleMobileCategoryChange() {
      const selectedCategory = this.selectedSegmentCategory;
      this.getSelectedSegmentCategory(null, selectedCategory);
    },
    // Download Images Menu
    initializeDownloadMenuTabs: function() {
      this.SWATCH_TAB_INDEX = 0;
      this.INSTALLATION_TAB_INDEX = 1;
      this.ROOMSCENE_TAB_INDEX = 2;
      this.initDownloadTab(this.tabs[this.SWATCH_TAB_INDEX], []);
      this.initDownloadTab(
        this.tabs[this.INSTALLATION_TAB_INDEX],
        this.installationMethodItems
      );
      this.initDownloadTab(
        this.tabs[this.ROOMSCENE_TAB_INDEX],
        this.roomSceneItems
      );
      this.selectedTab = this.tabs[this.SWATCH_TAB_INDEX];
    },
    initDownloadTab(element, items) {
      element.items = items;
    },
    selectDownloadTab(tab) {
      this.selectedTab = tab;
      if(this.selectedTab.name == "installation"){
        this.selectedImages.push(this.getdownloadInstallationMethod.name);
      }else{
        this.selectedImages = [];
      }
    },
    downloadImagesSelectAllHandler() {
      let slectedArray = []
      if((this.selectedTab.name === this.tabs[0].name) && (this.selectedImages.length !== this.availableVariations.length)) {
        this.availableVariations.forEach((variations) => {
          slectedArray.push(variations)
        });
      } else if((this.selectedTab.name === this.tabs[2].name) && this.selectedImages.length !== this.roomScenes.length) {
        this.roomScenes.forEach((roomscene) => {
          slectedArray.push(roomscene.data)
        });
      } 
      this.selectedImages = slectedArray;
    },
    async getAvailableVariations(
      styleNumber,
      colorNumber,
      selectedProductWidth,
      selectedProductHeight
    ) {
      this.availableVariations = [];

      let variation = 1;
      let isVariationAvailable;
      do {
        const requestUrl = this.$helpers.getTileImageUrl(
          styleNumber,
          colorNumber,
          selectedProductWidth,
          selectedProductHeight,
          variation
        );
        const response = await this.getImageStreamAsync(requestUrl);
        isVariationAvailable = response !== null;

        if (isVariationAvailable) {
          this.availableVariations.push(variation);
        }

        variation++;
      } while (isVariationAvailable);
      return this.availableVariations;
    },
    async getImageStreamAsync(url) {
      try {
        if (url) {
          const response = await fetch(url, {
            headers: {
              Origin: window.location.origin
            },
            mode: "cors"
          });

          if (response.ok) {
            return await response.blob();
          }
        }
      } catch (ex) {
        console.error(ex);
        return null;
      }
      return null;
    },
    getSwatchImageUrl: function(
      selectedProductWidth,
      selectedProductHeight,
      variant
    ) {
      if (variant != null || variant !== undefined)
        return this.$helpers.getTileImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber,
          selectedProductWidth,
          selectedProductHeight,
          variant
        );
    },
    async downloadImages() {
      const checkboxes = document.querySelectorAll(".image-checkbox");
      const spinner = document.getElementById("wf-download-modal-spiner");
      spinner.classList.remove("d-none");

      try {
        const zipScript = document.createElement("script");
        zipScript.src =
          "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.6.0/jszip.min.js";
        zipScript.onerror = () => {
          console.error("Error loading JSZip library.");
        };
        document.head.appendChild(zipScript);
        zipScript.onload = async () => {
          // Create a new zip instance
          const zip = new JSZip();
          for (let index = 0; index < checkboxes.length; index++) {
            const checkbox = checkboxes[index];
            if (checkbox.checked) {
              let fileName = `${this.sellingStyleNumber}_${this.selectedColor.colorNumber}`;
              if (this.selectedTab.name === this.tabs[1].name) {
                fileName += `_${this.getdownloadInstallationMethod.name}`;
              } else if (this.selectedTab.name === this.tabs[2].name) {
                fileName += `_room_scene_${index + 1}`;
              } else if (this.selectedTab.name === this.tabs[0].name) {
                fileName += `_swatch_${index + 1}`;
              }
              const imageUrl = checkbox.nextElementSibling
                .getAttribute("src")
                .replace(/\s/g, "");
              const updatedImageUrl = imageUrl.replace(
                /pixels=\d+/,
                "pixels=1000"
              );
              // const fileData = await fetch(updatedImageUrl , {cache: 'no-cache'}).then(response => response.blob());
              const fileData = await fetch(updatedImageUrl, {
                method: "GET", // Explicitly specifying the method as 'GET'
                headers: {
                  Origin: window.location.origin // Include the Origin header
                },
                mode: "cors" // Set the mode to 'cors'
              }).then(response => response.blob());
              // Add the image file to the zip
              zip.file(`${fileName}.jpg`, fileData);
              this.selectedImages.push(checkbox);
              console.log(`Image added to zip: ${updatedImageUrl}`);
            }
          }
          if (this.selectedImages.length > 0) {
            const zipBlob = await zip.generateAsync({ type: "blob" });
            const zipFileName = `${this.sellingStyleNumber}_${this
              .selectedImages.length / 2}_Patcraft_Assets.zip`;
            // Create a temporary <a> element to trigger the download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(zipBlob);
            link.download = zipFileName;
            link.click();
            if(this.selectedTab.name != "installation"){
              this.selectedImages = [];
            }
            // Clean up the temporary URL object
            setTimeout(function() {
              URL.revokeObjectURL(link.href);
            }, 100);
          }
        };
      } catch (error) {
        console.error("Error creating zip file:", error);
      } finally {
        spinner.classList.add("d-none");
      }
    },
    productRoomSceneViewModal(action) {
      this.viewProductType = action
      this.showModal("show-product-roomscene-view-hero");
    },
    productRoomSceneCloseModal() {
      this.productHeroModalType = null
      this.$modal.hide("show-product-roomscene-view-hero-modal");
    },
  },
  created: function() {
    WFTabContent.$helpers = this.$helpers;
    this.initializeDownloadMenuTabs();
    this.setProductData(this.product);
    this.setColors(this.mappedColors);
    this.setSellingStyleNumber(this.product.sellingStyleNumber);

    // Set the color specified in URL path, if available. Otherwise, set first color.
    let colorIndex = 0;
    const pathRegex = /product\/detail\/(?<styleNumber_url>\w+([-]?\w+)*)\/(?<colorNumber>\w+)/;
    const pathMatch = window.location.pathname.match(pathRegex);
    if (pathMatch) {
      colorIndex = Math.max(
        this.mappedColors.findIndex(
          c => c.colorNumber === pathMatch.groups.colorNumber
        ),
        0
      );
    }

    // Categories array stores cats from either style level or collection level that are then shown in the dropdown list
    if (!this.segments.length == 0) {
      this.segments.forEach((element, i) => {
        this.categories.push(this.segments[i].DataClass.Data[1]);
      });
    } else {
      this.collectionsegments.forEach((element, i) => {
        this.categories.push(this.collectionsegments[i].DataClass.Data[1]);
      });
    }

    this.updateColor(this.mappedColors[colorIndex]);

    let currentInstallation = this.installationMethods[0];
    this.setInstallationMethods(this.installationMethods);
    let url = new URL(window.location);
    const installationQueryValue = url.searchParams.get(
      this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME
    );

    //sets intial category value from segmentRoomScenes structure
    const categoryQueryValue = this.segmentRoomScenes.segmentRoomScenes[0]
      .segmentName;

    const roomSceneQueryValue = url.searchParams.get(
      this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME
    );

    if (installationQueryValue) {
      currentInstallation = this.installationMethods.find(
        i => i.name === installationQueryValue
      );
    } else {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME,
        currentInstallation.name
      );
    }
    if (this.categoriesWithoutDuplicates.length > 0) {
      this.selectedSegmentCategory = this.categoriesWithoutDuplicates[0];
      // Update the room scenes based on the default selected category
      this.getSelectedSegmentCategory(null, this.selectedSegmentCategory);
    }
    if (categoryQueryValue) {
      this.getSelectedSegmentCategory(null, categoryQueryValue);
    } else {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.CATEGORY_QUERY_PARAM_NAME,
        "General"
      );
    }

    if (roomSceneQueryValue) {
      let currentRoomSceneIndex = this.roomScenes.findIndex(
        i => i.data.toString() === roomSceneQueryValue
      );
      if (currentRoomSceneIndex >= 0) {
        this.setRoomSceneIndex(currentRoomSceneIndex);
        this.updateQueryStringParameters(
          this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
          this.roomScenes[currentRoomSceneIndex].data
        );
      }
    } else {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[0].data
      );
    }

    this.getSelectedProductDimensions();
    this.setInstallationMethod(currentInstallation);
    this.setdownloadInstallationMethod(currentInstallation);
    this.setProductVisualizerURL(this.$helpers.getPatcarftVisualizerLink(`${this.productData.inventoryType}-${this.productData.productTypeDesc}`, this.sellingStyleNumber, this.selectedColor.colorNumber, this.selectedInstallationMethod.tricycleCode));
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.getAvailableVariations(
      this.sellingStyleNumber,
      this.selectedColor.colorNumber,
      this.selectedProductWidth,
      this.selectedProductHeight
    );
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  components: {
    "wf-load-image": WFLoadImage,
    "pc-product-swatch-view-modal": PcProductSwatchViewModal,
    "wf-download-image-modal-tab-content": WFTabContent,
    "pc-product-download-view-modal": pcProductDownloadViewModal,
    "pc-view-options": PcViewOptions,
    "pc-product-swatch-roomscene-view-hero-modal": PcProductSwatchRoomsceneViewHeroModal
  }
};
</script>

